import axios from "axios";
const dataUrl = "https://eyamweb20240304100030.azurewebsites.net/api/";
//const dataUrl = "https://localhost:7229/api/";
//const dataUrl = "https://fasttanboard0.conveyor.cloud/api/";
const dataGraphQl = "https://eyamweb20240304100030.azurewebsites.net";

export async function AjaxGet(authInfo, controller) {
  try {
    const res = await axios.get(`${dataUrl}${controller}`, {
      headers: {
        Authorization: `Bearer ${authInfo.apiToken}`,
      },
    });
    if (res?.response?.status && res?.response?.status != 200) {
      return { error: response.data.message };
    }
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function AjaxGetAnon(controller) {
  try {
    const res = await axios.get(`${dataUrl}${controller}`, {});
    if (res?.response?.status && res?.response?.status != 200) {
      return { error: response.data.message };
    }
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function AjaxGetDiscoverListing(discoverId, viewerUserId, apiToken) {
  const query = viewerUserId
    ? `?viewerUserId=${encodeURIComponent(viewerUserId)}`
    : "";
  const controller = `Discover/${discoverId}${query}`;

  const response = apiToken
    ? await AjaxGet({ apiToken }, controller)
    : await AjaxGetAnon(controller);

  return response?.data ?? null;
}

export async function AjaxGetAnonOwnLink(controller) {
  try {
    const res = await axios.get(`${controller}`, {});
    if (res?.response?.status && res?.response?.status != 200) {
      return { error: response.data.message };
    }
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function AjaxPost(authInfo, controller, data) {
  try {
    const res = await axios.post(
      `${dataUrl}${controller}`,
      JSON.stringify(data),
      {
        headers: {
          "content-type": "text/json",
          Authorization: "Bearer " + authInfo.apiToken,
        },
      }
    );
    if (res?.response?.status && res?.response?.status != 200) {
      return { error: response.data.message };
    }
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function AjaxPostAnon(controller, data) {
  try {
    const res = await axios.post(
      `${dataUrl}${controller}`,
      JSON.stringify(data),
      {
        headers: {
          "content-type": "text/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST",
        },
      }
    );
    if (res?.response?.status && res?.response?.status != 200) {
      return { error: response.data.message };
    }
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function AjaxPostAnonFile(controller, data) {
  try {
    const res = await axios.post(`${dataUrl}${controller}`, data, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function AjaxGetAddressAutoComplete(address) {
  try {
    const res = await axios.get(
      `https://api.geoapify.com/v1/geocode/search?text=${address}&apiKey=0720acec30e74d67a7cadba290e65e52`,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function AjaxGetAddressReverseGeoCode(lat, long) {
  try {
    const res = await axios.get(
      `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${long}&apiKey=0720acec30e74d67a7cadba290e65e52`,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
}

export async function AjaxGraphQL(data) {
  try {
    const res = await axios({
      url: `${dataGraphQl}/graphql`,
      method: "post",
      data: {
        query: `${data}`,
      },
    });
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
}
